/* eslint-disable @typescript-eslint/no-magic-numbers */
import styled from 'styled-components'

export const CaroulselTitleContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-shrink: 0;
    white-space: pre;
    margin-bottom: 8px;
`
export const CaroulselTitle = styled.h1`
    font-family: ${properties => properties.theme.variables.fontFamily.title};
    color: ${properties => properties.theme.variables.colorText};
    font-weight: 600;
    font-size: 1.5rem;
    line-height: 1.2em;
    letter-spacing: -0.03rem;
    text-align: start;
`
export const CustomCarousel = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;
    max-height: 420px;
    @media only screen and (min-width: 810px) {
        flex-direction: row;
        max-height: 401px;
        justify-content: space-between;
    }
`

export const ContainerTag = styled.div`
    position: absolute;
    padding: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
    height: 100%;
    z-index: 1;
    @media only screen and (min-width: 810px) {
        height: unset;
        background-color: rgba(0, 0, 0, 0.5);
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        border-radius: 12px 12px 0px 0px;
    }
`

export const ContainerImage = styled.div`
    flex-direction: row;
    height: 125px;
    gap: 1.5rem;
    width: 118px;
    @media only screen and (min-width: 810px) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 278px;
        width: 100%;
    }
    > * {
        > * {
            object-fit: cover;
            height: 125px;
            width: 118px;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            @media only screen and (min-width: 810px) {
                border-top-right-radius: 10px;
                border-bottom-right-radius: 0;
                border-bottom-left-radius: 0;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: 278px;
                width: 100%;
            }
        }
    }
`
export const ContainerText = styled.div`
    display: flex;
    color: ${properties => properties.theme.variables.colorText};
    flex-direction: column;
    padding: 0 0.75rem;
    flex: 1;
`
export const ContainerTextDesc = styled.div`
    width: 100%;
    font-size: 0.75rem;
    font-weight: 500;
    opacity: 0.8;
    line-height: 150%;
    font-family: ${properties => properties.theme.variables.fontFamily.title};
    color: ${properties => properties.theme.variables.colorText};
`
export const ContainerTextTitle = styled.div`
    font-weight: bold;
    font-size: 1rem;
    line-height: 1.2em;
    padding-bottom: 0.3rem;
    font-family: ${properties => properties.theme.variables.fontFamily.title};
    color: ${properties => properties.theme.variables.colorText};
`
export const ContainerTextFooter = styled.div`
    display: flex;
    padding: 0 0.75rem 0.75rem 0.75rem;
    flex: 1;
    > * {
        font-family: ${properties => properties.theme.variables.fontFamily.text};
        color: ${properties => properties.theme.variables.colorText};
        font-weight: 600;
        font-size: 14px;
        line-height: 100%;
        opacity: 0.8;
    }
    align-items: self-end;
    flex-direction: row;
    justify-content: space-between;
`
export const Container = styled.div`
    border-radius: 0.75rem;
    position: relative;
    cursor: pointer;
    max-height: 100%;
    width: 100%;
    display: flex;
    border: 1px solid ${properties => properties.theme.variables.colorGray.secondary};
    border-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    @media only screen and (min-width: 810px) {
        flex-direction: column;
    }
    @media only screen and (min-width: 1179px) {
        max-width: 369px;
    }
`
export const BagdgeContainer = styled.div`
    border-radius: 100px;
    background-color: #fff;
    padding: 2px 8px;
    span {
        font-family: ${properties => properties.theme.variables.fontFamily.title};
        font-weight: 600;
        font-size: 12px;
        line-height: 1.2em;
    }
    .bagdge-container-private {
        color: ${properties => properties.theme.variables.colorWarning.primary};
    }
    .bagdge-container-public {
        color: ${properties => properties.theme.variables.colorPrimary};
    }
`

export const CustomCarouselCounterWrapper = styled.div<{ is_index_0: boolean; is_last_index: boolean }>`
    display: flex;
    flex-direction: row;
    color: ${properties => properties.theme.variables.colorText};
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    gap: 2rem;
    .carousel-control-next-icon {
        height: 40px;
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        opacity: ${properties => (properties.is_last_index ? 0.5 : 1)};
        cursor: ${properties => (properties.is_last_index ? 'normal' : 'pointer')};
        background-color: ${properties =>
            properties.is_last_index
                ? properties => properties.theme.variables.colorGray.secondary
                : properties.theme.variables.colorPrimary};
        margin-left: 30px;
    }

    .carousel-control-prev-icon {
        height: 40px;
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        cursor: ${properties => (properties.is_index_0 ? 'normal' : 'pointer')};
        opacity: ${properties => (properties.is_index_0 ? 0.5 : 1)};
        background-color: ${properties =>
            properties.is_index_0
                ? properties => properties.theme.variables.colorGray.secondary
                : properties.theme.variables.colorPrimary};
        margin-right: 30px;
    }
`
export const CustomCarouselCounterWrapperText = styled.div<{ isSelected: boolean }>`
    font-weight: bold;
    font-size: 1rem;
    display: flex;
    align-items: center;
    cursor: pointer;
    line-height: 1.2em;
    color: ${properties => (properties.isSelected ? '#000' : properties.theme.variables.colorText)};
    background-color: ${properties => properties.isSelected && properties.theme.variables.colorPrimary};
    border-radius: ${properties => properties.isSelected && '17px'};
    align-self: center;
    padding: ${properties => properties.isSelected && '6px 12px 6px 12px'};
    opacity: ${properties => (properties.isSelected ? '1' : '0.2')};
`
export const ContainerTexts = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 12px;
    font-family: ${properties => properties.theme.variables.fontFamily.title};
    color: ${properties => properties.theme.variables.colorText};
    @media only screen and (min-width: 810px) {
        height: 115px;
    }
`
